import { render, staticRenderFns } from "./noteregister.vue?vue&type=template&id=433b155a&scoped=true&"
import script from "./noteregister.vue?vue&type=script&lang=js&"
export * from "./noteregister.vue?vue&type=script&lang=js&"
import style0 from "./noteregister.vue?vue&type=style&index=0&id=433b155a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433b155a",
  null
  
)

export default component.exports